const SHOW_ERROR_MODAL = 'SHOW_ERROR_MODAL';
const HIDE_ERROR_MODAL = 'HIDE_ERROR_MODAL';

export { SHOW_ERROR_MODAL, HIDE_ERROR_MODAL };
